import React from 'react';
import { BACKBONE_APP_ROOT } from 'js/backbone/constants';

export const BackboneWrapper = ({ el, tagName, classes, children }) => {

    if (tagName === 'span') {
        return (
            <span className={BACKBONE_APP_ROOT}>
                <span ref={el} className={classes}>
                    {children}
                </span>
            </span>
        );
    }

    return (
        <div className={BACKBONE_APP_ROOT}>
            <div ref={el} className={classes}>
                {children}
            </div>
        </div>
    );
};
